module.exports = __webpack_public_path__ + "static/media/icon_removelight.bcdca67c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_removelight.svg
// module id = 868
// module chunks = 7